import React from "react";
import useConfig from "@hooks/useConfig";
import { Mail, MapPin, Phone } from "lucide-react";

// Shared Styles
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Label,
  Value,
} from "../../styles";

const StoreInfo = ({ order }: any) => {
  // Try to find store info from first product
  const store =
    order?.items?.[0]?.product?.store ||
    order?.items?.[0]?.infos?.product?.store ||
    {};
  const { bucketUrl } = useConfig();

  if (!store.name) return null;

  // Helper to render rows
  const InfoRow = ({
    icon: Icon,
    label,
    value,
  }: {
    icon: any;
    label: string;
    value: string;
  }) => (
    <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
      <div
        style={{
          minWidth: "32px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f0fdfa",
          borderRadius: "8px",
          color: "#0d9488",
        }}
      >
        <Icon size={16} />
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <Label>{label}</Label>
        <Value>{value}</Value>
      </div>
    </div>
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Store Details</CardTitle>
      </CardHeader>

      <CardContent>
        {/* Avatar & Name */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            paddingBottom: "20px",
            marginBottom: "20px",
            borderBottom: "1px dashed #e5e7eb",
          }}
        >
          <img
            src={
              store.avatar
                ? `${bucketUrl}/${store.avatar}`
                : "https://placehold.co/100?text=Store"
            }
            alt="Store"
            style={{
              width: "56px",
              height: "56px",
              borderRadius: "50%",
              objectFit: "cover",
              backgroundColor: "#f0fdfa",
              border: "2px solid #fff",
              boxShadow: "0 0 0 1px #e5e7eb",
            }}
            onError={(e) => {
              e.currentTarget.src = "https://placehold.co/100?text=Store";
            }}
          />
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <span
              style={{
                fontSize: "16px",
                fontWeight: 600,
                color: "#111827",
              }}
            >
              {store.name}
            </span>
            <span style={{ fontSize: "13px", color: "#6b7280" }}>Vendor</span>
          </div>
        </div>

        {/* Contact Info */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <InfoRow
            icon={Phone}
            label="Phone"
            value={store.phoneNo || store.phoneNumber || "N/A"}
          />
          <InfoRow icon={Mail} label="Email" value={store.email || "N/A"} />
          <InfoRow
            icon={MapPin}
            label="Address"
            value={store.address || "N/A"}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default StoreInfo;
